import * as yup from "yup";
import {
  createImageFileSchema,
  createRequiredTrimmedString,
} from "./schemaUtils";

export const adminSettingCompanySchemas = yup
  .object({
    company_name: createRequiredTrimmedString("Name is required").test(
      "len",
      "Checkpoint name must be between 1 and 30 characters long",
      (val) => val && val.length <= 30
    ),
    domain: createRequiredTrimmedString("URL is required"),
  })
  .required();

  export const adminSettingLogoSchemas = yup
    .object({
      logo: createImageFileSchema(),
      favicon: createImageFileSchema(),
    })
    .required();


  export const adminSettingLDAPSettingsSchemas = yup
    .object({
      ldap_url: yup
        .string()
        .nullable()
        .notRequired()
        .test(
          "is-valid-ldap-url",
          "Invalid LDAP URL format",
          (value) =>
            !value ||
            /^(ldap[s]?:\/\/)?(?:\[([^\]]+)\]|([^:/?#]+)):(\d+)$/.test(value)
        ),
      ldap_base_dn: yup.string(),
      ldap_user: yup.string(),
      ldap_password: yup.string(),
    })
